import { Link } from "react-router-dom";
import { CameraIcon } from "./review-icons";

/**
 * Inventory's Scan cards, for every role, on both panes: floating at the thumb on a phone, as iOS's, and in the panel's
 * head from 640 px (`place="head"`), where a floating button would sit over the list. `returnTo` is the page opening the
 * scanner, so Done goes back to it when that is where the scanner lands.
 */
export function ScanCardsLink({ returnTo, place }: { returnTo?: string; place?: "head" }) {
  return (
    <Link
      to="/scan"
      state={returnTo ? { returnTo } : undefined}
      data-floating={place === "head" ? undefined : "button"}
      className={
        place === "head"
          ? "btn-primary btn-sm ml-auto hidden sm:inline-flex"
          : "btn-primary fixed right-[max(1rem,env(safe-area-inset-right))] bottom-[calc(var(--tab-bar,0px)+1.5rem)] z-20 flex h-[52px] items-center gap-2 rounded-full px-5 shadow-lg sm:hidden"
      }
    >
      <CameraIcon />
      Scan cards
    </Link>
  );
}
